import { BrowserRouter, Navigate, Outlet, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AppLayout } from './components/AppLayout';
import { LoginPage } from './pages/LoginPage';
import { HomePage } from './pages/HomePage';
import { LawsPage } from './pages/LawsPage';
import { LawDetailPage } from './pages/LawDetailPage';
import { ArticlePage } from './pages/ArticlePage';
import { SearchPage } from './pages/SearchPage';
import { FeedPage } from './pages/FeedPage';
import { HighlightsPage } from './pages/HighlightsPage';
import { ProfilePage } from './pages/ProfilePage';
import { RegisterPage } from './pages/RegisterPage';
import { RecoverPage } from './pages/RecoverPage';
import { ClasificaPage } from './pages/ClasificaPage';

function LandingRedirect() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div style={{ minHeight: 'var(--lex-viewport-height)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#1976D2' }}>
        Cargando…
      </div>
    );
  }
  if (user) {
    return <Navigate to="/inicio" replace />;
  }
  return <Navigate to="/login" replace />;
}

function ExternalDofiaRedirect() {
  window.location.replace('https://dumas.solutions/dofia');
  return null;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/registro" element={<RegisterPage />} />
      <Route path="/recuperar" element={<RecoverPage />} />
      <Route path="/" element={<Outlet />}>
        <Route index element={<LandingRedirect />} />
        <Route element={<ProtectedRoute><Outlet /></ProtectedRoute>}>
          <Route element={<AppLayout />}>
            <Route path="inicio" element={<HomePage />} />
            <Route path="leyes" element={<LawsPage />} />
            <Route path="leyes/:lawId" element={<LawDetailPage />} />
            <Route path="leyes/:lawId/articulo/:articleId" element={<ArticlePage />} />
            <Route path="buscar" element={<SearchPage />} />
            <Route path="feed" element={<FeedPage />} />
            <Route path="dof" element={<ExternalDofiaRedirect />} />
            <Route path="clasifica" element={<ClasificaPage />} />
            <Route path="resaltados" element={<HighlightsPage />} />
            <Route path="perfil" element={<ProfilePage />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
